import { CustomerCustomFieldDataType } from "@redotech/redo-customer-segments-common/customer-custom-fields/customer-custom-fields-definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createCustomField = {
  name: "createCustomField" as const,
  input: z.object({
    name: z.string().min(1, "Field name is required"),
    dataType: createEnum(CustomerCustomFieldDataType),
    isMultiValued: z.boolean().default(false),
    options: z.array(z.string()).optional(),
  }),
  output: z.object({ success: z.boolean(), declarationId: zExt.objectId() }),
};
